module.exports = __webpack_public_path__ + "static/img/fingerpost_order_3.d5fdddb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_order_3.jpg
// module id = qK4H
// module chunks = 0